'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHighcharts = require('react-highcharts');

var _reactHighcharts2 = _interopRequireDefault(_reactHighcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultConfigs = require('./defaultChartConfig.json');

var ReportChart = function (_React$Component) {
    (0, _inherits3.default)(ReportChart, _React$Component);

    function ReportChart(props) {
        (0, _classCallCheck3.default)(this, ReportChart);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReportChart.__proto__ || (0, _getPrototypeOf2.default)(ReportChart)).call(this, props));

        _this.config = (0, _assign2.default)(defaultConfigs, props.config);
        return _this;
    }

    (0, _createClass3.default)(ReportChart, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_reactHighcharts2.default, { config: this.config, ref: 'chart' });
        }
    }]);
    return ReportChart;
}(_react2.default.Component);

exports.default = ReportChart;
module.exports = exports['default'];